import { FC } from "react"

const DropdownItem: FC<DropdownItemProps> = ({ title, onClick }) => {
    return <div onClick={() => onClick(title)}>{title}</div>
}

export default DropdownItem